"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.action = exports.deleteSubscription = exports.cancelIndividualSubscription = exports.postIndividualPaymentIntent = exports.fetchIndividualDefaultPayment = exports.putRetryInvoice = exports.putIndividualDefaultPaymentMethod = exports.postCompanySubscription = exports.fetchCompanySubscription = exports.postIndividualSubscription = exports.fetchIndividualSubscription = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const axios_1 = __importDefault(require("axios"));
const apiRoutes_1 = require("../apiRoutes");
exports.fetchIndividualSubscription = (0, toolkit_1.createAsyncThunk)("subscription/fetchIndividualSubscription", ({}) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.get((0, apiRoutes_1.subscriptionAPI)("/individual"));
    return data;
}));
exports.postIndividualSubscription = (0, toolkit_1.createAsyncThunk)("subscription/postIndividualSubscription", ({ cb }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.post((0, apiRoutes_1.stripeAPI)("/subscribe/individual"));
    cb(data);
    return data;
}));
exports.fetchCompanySubscription = (0, toolkit_1.createAsyncThunk)("subscription/fetchCompanySubscription", ({}) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.get((0, apiRoutes_1.subscriptionAPI)("/company"));
    return data;
}));
exports.postCompanySubscription = (0, toolkit_1.createAsyncThunk)("subscription/postCompanySubscription", ({}) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.post((0, apiRoutes_1.stripeAPI)("/subscribe/enterprise"));
    return data;
}));
exports.putIndividualDefaultPaymentMethod = (0, toolkit_1.createAsyncThunk)("subscription/putIndividualDefaultPaymentMethod", ({ paymentMethodId, cb }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.put((0, apiRoutes_1.stripeAPI)(`/payment-method/individual/${paymentMethodId}`));
    cb(data);
}));
exports.putRetryInvoice = (0, toolkit_1.createAsyncThunk)("subscription/putRetryInvoice", ({ cb }) => __awaiter(void 0, void 0, void 0, function* () {
    yield axios_1.default.put((0, apiRoutes_1.stripeAPI)(`/retry-invoice`));
    cb();
}));
exports.fetchIndividualDefaultPayment = (0, toolkit_1.createAsyncThunk)("subscription/fetchIndividualDefaultPayment", ({ cb }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios_1.default.get((0, apiRoutes_1.stripeAPI)(`/default-payment`));
    cb(response.data);
}));
exports.postIndividualPaymentIntent = (0, toolkit_1.createAsyncThunk)("subscription/postIndividualPaymentIntent", ({ cb }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios_1.default.post((0, apiRoutes_1.stripeAPI)(`/create-intent/individual`));
    cb(response.data);
}));
exports.cancelIndividualSubscription = (0, toolkit_1.createAsyncThunk)("subscription/cancelIndividualSubscription", ({ type }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.put((0, apiRoutes_1.stripeAPI)(`/cancel-subscription/individual`));
}));
exports.deleteSubscription = (0, toolkit_1.createAsyncThunk)("subscription/deleteSubscription", ({ type }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield axios_1.default.delete((0, apiRoutes_1.subscriptionAPI)(`/${type}`));
    return type;
}));
const INIT_STATE = {
    subscription: {
        individual: {},
        company: {},
    },
    isLoading: false,
    hasError: false,
};
//Slice
/////////////////////////////////////////////////////////////
const subscriptionSlice = (0, toolkit_1.createSlice)({
    name: "subscription",
    initialState: INIT_STATE,
    reducers: {
        action(state, action) {
            return Object.assign({}, state);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.fetchIndividualSubscription.fulfilled, (state, action) => {
            state.subscription = Object.assign(Object.assign({}, state.subscription), { individual: action.payload });
            state.isLoading = false;
            state.hasError = false;
        })
            .addCase(exports.fetchIndividualSubscription.rejected, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
        })
            .addCase(exports.postIndividualSubscription.fulfilled, (state, action) => {
            state.subscription = Object.assign(Object.assign({}, state.subscription), { individual: action.payload });
            state.isLoading = false;
            state.hasError = false;
        })
            .addCase(exports.postIndividualSubscription.rejected, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
        })
            .addCase(exports.fetchCompanySubscription.fulfilled, (state, action) => {
            state.subscription = Object.assign(Object.assign({}, state.subscription), { company: action.payload });
            state.isLoading = false;
            state.hasError = false;
        })
            .addCase(exports.fetchCompanySubscription.rejected, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
        })
            .addCase(exports.postCompanySubscription.fulfilled, (state, action) => {
            state.subscription = Object.assign(Object.assign({}, state.subscription), { company: action.payload });
            state.isLoading = false;
            state.hasError = false;
        })
            .addCase(exports.postCompanySubscription.rejected, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
        })
            .addCase(exports.deleteSubscription.fulfilled, (state, action) => {
            state.subscription = Object.assign(Object.assign({}, state.subscription), { [action.payload]: null });
            state.isLoading = false;
            state.hasError = false;
        })
            .addCase(exports.deleteSubscription.rejected, (state, action) => {
            state.isLoading = false;
            state.hasError = true;
        });
    },
});
//Actions
/////////////////////////////////////////////////////////////
exports.action = subscriptionSlice.actions.action;
//Reducer
/////////////////////////////////////////////////////////////
exports.default = subscriptionSlice.reducer;
